import { Site } from '@debbie/common/dist/index.js';
import { TenantStatus } from '@debbie/common/dist/tenants/index.js';
import { useCreditor } from '@debbie/cortex/dist/creditors/index.js';
import { c, h } from '@debbie/cortex/dist/index.js';
import { useMe, useRole } from '@debbie/cortex/dist/me/index.js';
import { useTenant, useTenantId } from '@debbie/cortex/dist/tenant/index.js';
import React, { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
import { Badge, Button, ExclusiveContent, Modal, Search } from '..//index.js';
import ActiveUsers from '../ActiveUsers.js';
import CopyToClipboard from '../CopyToClipboard.js';
import MoreVertical from '../Icons/MoreVertical.js';
import SearchIcon from '../Icons/Search.js';
import TenantStatusBadge from '../TenantStatusBadge.js';
import UserPreview from '../UserPreview.js';
import Hamburger from './Hamburger.js';
const TopNav = (props) => {
    const selectedCreditor = useSelector((s) => s.selectedCreditor);
    const selectedTenantId = useTenantId();
    const leftNavOpen = useSelector((s) => s.leftNavOpen);
    const site = useSelector((s) => s.site);
    const meLoadable = useMe();
    const me = h.hasData(meLoadable) ? meLoadable.data : null;
    const _tenant = useTenant();
    const meRole = useRole();
    const creditorLoadable = useCreditor(selectedCreditor || undefined);
    const creditor = h.hasData(creditorLoadable) ? creditorLoadable.data : null;
    const [searchModalOpen, setSearchModalOpen] = useState(false);
    const menu = useRef(null);
    const { button } = props;
    const tenant = me && me.tenants.find((tenant) => tenant.id === selectedTenantId);
    return (React.createElement(TopNavStyled, { open: leftNavOpen },
        React.createElement(Hamburger, { className: "hamburger", open: leftNavOpen, onClick: () => {
                c.local.toggleLeftNav();
            } }),
        React.createElement(Search, { style: {
                marginLeft: leftNavOpen ? '0px' : '40px',
                transition: 'margin-left .25s',
                background: 'F3F3F3',
            }, className: "normal-search" }),
        React.createElement("div", { className: "search-in-modal" },
            React.createElement(SearchIcon, { onClick: () => setSearchModalOpen(!searchModalOpen), style: {
                    margin: '4px 0 0 43px',
                    height: '20px',
                    width: '20px',
                } }),
            searchModalOpen && (React.createElement(Modal, { onToggle: () => setSearchModalOpen(!searchModalOpen) },
                React.createElement(Search, { style: {
                        width: '100%',
                        display: 'block',
                    } })))),
        React.createElement("div", { className: "t-fr navbar-top-right" },
            button && (React.createElement(Button, { style: {
                    marginRight: '15px',
                }, size: "small", onClick: button.onClick, theme: button.theme }, button.text)),
            site === Site.Caseworker && React.createElement(ActiveUsers, null),
            React.createElement(Menu, { ref: menu },
                React.createElement("p", { style: {
                        display: 'inline-block',
                        marginRight: '10px',
                    } },
                    tenant && tenant.status !== TenantStatus.Active && (React.createElement(TenantStatusBadge, { status: tenant.status })),
                    creditor && React.createElement(ReferenceId, { creditor: creditor, tenant: _tenant })),
                React.createElement(TenantSelector, { onClick: () => {
                        c.local.toggleRightNav();
                    } },
                    me && meRole && (React.createElement(UserPreview, { user: { ...me, role: meRole }, style: { display: 'inline-block', verticalAlign: 'middle' }, tooltipToLeft: true })),
                    React.createElement("div", { style: {
                            display: 'inline-block',
                            verticalAlign: 'middle',
                            margin: '0px 5px 5px 5px',
                        }, className: "tenant-and-user" },
                        React.createElement("div", { style: { maxWidth: '142px' } }, me && `${me.firstName} ${me.lastName}`),
                        React.createElement("div", { style: {
                                fontWeight: 'normal',
                                maxWidth: '142px',
                                marginTop: '4px',
                            } }, site == Site.Client
                            ? creditor && creditor.name
                            : tenant && (React.createElement(React.Fragment, null,
                                React.createElement(ExclusiveContent, null,
                                    React.createElement(CopyToClipboard, { text: tenant.id }),
                                    ' '),
                                tenant.name)))),
                    React.createElement(MoreVertical, { style: {
                            height: '20px',
                            width: '20px',
                        } }))))));
};
export default TopNav;
const TopNavStyled = styled.nav `
  display: flex;
  justify-content: space-between;
  background-color: ${THEME.COLOR_SECONDARY};
  height: 60px;
  left: ${THEME.NAV_LEFT_WIDTH}px;
  padding: 15px;
  top: 0px;

  a {
    color: inherit;
  }

  #custom-actions {
    display: inline-block;

    button {
      margin-right: 10px;
    }
  }

  .iris-input-container input {
    background: #f3f3f3;
  }

  .user {
    margin-left: 10px;
    padding-left: 10px;

    svg {
      height: 20px;
    }
  }

  .navbar-top-right > * {
    vertical-align: middle;
  }

  .navbar-top-right {
    display: flex;
    align-items: center;
    float: right;
    margin-top: -15px;
    margin-left: -15px;
    height: ${THEME.NAV_TOP_HEIGHT}px;
  }

  .hamburger {
    margin-left: ${(props) => (props.open ? '-60px' : '0px')};
    opacity: ${(props) => (props.open ? 0 : 1)};
    transition: margin 0.25s ease-in-out;
  }

  .breadcrumb {
    background-color: transparent;
    float: left;
    font-size: 1.5em;
    font-weight: 300;
    line-height: 30px;
    margin: 0;
    padding: 0;
    padding-left: ${(props) => (props.open ? '0px' : '35px')};
    transition: padding 0.25s ease-in-out;

    a {
      text-decoration: none;
    }

    a:hover {
      text-decoration: underline;
    }

    .active {
      font-weight: 400;
    }

    a:last-child,
    div:last-child {
      font-weight: bold;
    }
  }

  .search-in-modal {
    display: none !important;
  }

  @media ${THEME.MEDIA_QUERY_MOBILE} {
    .tenant-and-user {
      display: none !important;
    }

    .normal-search {
      display: none !important;
    }

    .search-in-modal {
      display: inline !important;
    }
  }
`;
const Menu = styled.div `
  height: ${THEME.NAV_TOP_HEIGHT}px;
  display: inline-block;
  flex-shrink: 0;
`;
const TenantSelector = styled.div `
  padding: 10px 15px;
  float: right;
  max-width: 240px;
  user-select: none;
  cursor: pointer;

  & > div > div,
  & > small {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  & > div > div {
    font-weight: bold;
    margin-bottom: -5px;
  }

  svg {
    margin: 3px 0 -3px 5px;
  }
`;
const ReferenceId = (props) => {
    const { tenant, creditor } = props;
    const site = useSelector((s) => s.site);
    if (site === Site.Client) {
        return creditor?.id ? (React.createElement(Badge, { style: { marginLeft: '5px' }, theme: THEME.DARK_COLOR_SECONDARY }, creditor.id)) : null;
    }
    if (site === Site.Caseworker && tenant?.status === TenantStatus.Active) {
        return tenant?.referenceId ? (React.createElement(Badge, { style: { marginLeft: '5px' }, theme: THEME.DARK_COLOR_SECONDARY }, tenant.referenceId)) : (React.createElement(ExclusiveContent, null,
            React.createElement(Badge, { style: { marginLeft: '5px' }, theme: THEME.WARNING }, "Tenant ref.id missing")));
    }
    return null;
};
//# sourceMappingURL=TopNav.js.map